import { render, staticRenderFns } from "./DisputeResolution.vue?vue&type=template&id=20bbd9fd&scoped=true"
import script from "./DisputeResolution.vue?vue&type=script&lang=js"
export * from "./DisputeResolution.vue?vue&type=script&lang=js"
import style0 from "./DisputeResolution.vue?vue&type=style&index=0&id=20bbd9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbd9fd",
  null
  
)

export default component.exports